<template>
  <div class="app-bar-search">
    <v-btn
      icon
      small
      class="app-bar-search-toggler"
      @click="toggle"
    >
      <v-icon>
        {{ icons.mdiMagnify }}
      </v-icon>
    </v-btn>

    <v-expand-x-transition>
      <v-text-field
        v-show="isOpen"
        ref="searchInput"
        v-model="query"
        class="app-bar-search-box"
        rounded
        dense
        outlined
        hide-details="auto"
        autofocus
        :placeholder="$t('Haku')"
        :append-icon="icons.mdiMagnify"
        :rules="[queryLengthRule]"
        @click:append="submit"
        @keyup.enter="submit"
        @keyup.esc="close"
        @blur="close"
      ></v-text-field>
    </v-expand-x-transition>
  </div>
</template>

<script>
import { ref, nextTick } from '@vue/composition-api'
import { useRouter } from '@core/utils'
import { mdiMagnify } from '@mdi/js'
import { useTranslations } from '@core/libs/i18n'

const MIN_QUERY_LENGTH = 3

export default {
  setup() {
    const { router } = useRouter()
    const { t } = useTranslations()
    const isOpen = ref(false)
    const query = ref('')
    const searchInput = ref(null)

    const toggle = () => {
      isOpen.value = !isOpen.value
      if (isOpen.value) {
        nextTick(() => searchInput.value && searchInput.value.focus())
      }
    }

    const close = () => {
      isOpen.value = false
    }

    const queryLengthRule = value => {
      const trimmed = (value || '').trim()

      return !trimmed || trimmed.length >= MIN_QUERY_LENGTH
        || t(`Hakusanan tulee olla vähintään ${MIN_QUERY_LENGTH} merkkiä pitkä`)
    }

    const submit = () => {
      const q = query.value.trim()
      if (q.length < MIN_QUERY_LENGTH) return

      router.push({ name: 'search', query: { q } })
      query.value = ''
      isOpen.value = false
    }

    return {
      isOpen,
      query,
      searchInput,
      toggle,
      close,
      submit,
      queryLengthRule,
      icons: {
        mdiMagnify,
      },
    }
  },
}
</script>

<style scoped>
.app-bar-search {
  display: flex;
  align-items: center;
}

.app-bar-search-box {
  width: 220px;
  margin-left: 8px;
}
</style>
